export default "__VITE_ASSET__Bs_F7K8a__"